export default formValues => ({
  callPreference: formValues.contact_preferences.call,
  email: formValues.email,
  emailPreference: formValues.contact_preferences.email,
  name: formValues.name,
  notes: formValues.notes,
  phone: formValues.phone_number,
  textPreference: formValues.contact_preferences.text
});
